import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { CheckPaymentModalComponent } from "../../../modals/check-payment-modal/check-payment-modal.component";
import { HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";
import { Subject } from "rxjs";
import { CustomerDashboardService } from "src/app/pages/customer-dashboard/services/customer-dashboard.service";


@Component({
  selector: "fury-agreements-table",
  templateUrl: "./agreements-table.component.html",
  styleUrls: ["./agreements-table.component.scss"],
})
export class AgreementsTableComponent implements OnInit {
  @Input() displayedColumns: any[];
  @Input() dataSource: any[]=[];
  @Input() editorAccess:boolean;
  @Output() getRowData = new EventEmitter<any>();
  ngUnSubscribe = new Subject<void>();
  userId = "";
  constructor(
    public commonService: CommonService,
     private apiService: ApiService,
     private activateRoute: ActivatedRoute,
     public dialog: MatDialog,
     private customerDashboardService: CustomerDashboardService
    ) {}

  ngOnInit(): void {
    this.userId = this.activateRoute.snapshot.params["id"];
  }

  formatCurrency(priceValue) {
    if (!priceValue) return  "$0.00";
    return `$${Number(priceValue)?.toFixed(2)}`;
  }

  getWaitingPeriod(days) {
    if (!days) return "";
    if (Number(days) === 1) return `${days} day`;
    return `${days} days`;
  }

  handleRowClick(row) {
    if (!row?.serviceAgreementPdf) {
      this.apiService.alert("Service Agreement PDF Not Found", ErrorType.Error);
      return;
    }
    window.open(row?.serviceAgreementPdf, '_blank');

  }

  getServiceAgreementPdf(row: any) {
    this.apiService
      .get(
        `${endpoints.customerServiceAgreement.getAgreementPdf(row?.orderId, 1)}`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body?.serviceAgreementPdf) {
            window.open(res.body?.serviceAgreementPdf, "_blank");
          } else {
            this.apiService.alert(
              "Service Agreement PDF Not Found",
              ErrorType.Error
            );
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  
  handleEscrowPayment(row) {
    const data = {
      agreementId : row?.orderId
    }
    this.dialog
      .open(CheckPaymentModalComponent, {
        data: data,
        width: "600px",
        panelClass: "payment-info",
      })
      .afterClosed()
      .subscribe((res: any) => {
        if (!res?.actionValue) return;
  
      });
  }


  handleAddNotes(rowData: any) {
    const {agreementNumber} = rowData;
    if (!agreementNumber || !this.userId) return;
    this.customerDashboardService.handleAddNotes(this.userId, null, false, agreementNumber, null);
  }

  handleAddSpecialRequest(rowData: any) {
    const {agreementNumber} = rowData;
    if (!agreementNumber || !this.userId) return;
    
    this.customerDashboardService.handleSpecialRequest(this.userId, null, false, null, agreementNumber);
  }

  handleAddFeedback(rowData: any) {
    const {agreementNumber} = rowData;
    if (!agreementNumber || !this.userId) return;
    this.customerDashboardService.handleFeedbackRequest(this.userId, null, false, null, agreementNumber);
  }
  handleViewAgreement(rowData: any) {
    const {orderId} = rowData;
    if (!orderId || !this.userId) return;
    this.apiService.routeToPage(`customer-dashboard/${this.userId}/view-agreement/${orderId}`)
 
  }
  handleAgreement(data: any){
    this.getRowData.emit(data)
  }
  handleFileClaimWithAgreement(rowData: any){
    const {agreementNumber} = rowData;
    if (!agreementNumber || !this.userId) return;
    this.apiService.routeToPage(`customer-dashboard/${this.userId}/file-a-claim?agreementNumber=${agreementNumber}`);
  }

  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
